import React, { Component } from 'react';
import NCReasonsTemplate from './NCReasonsTemplate';
import _ from 'lodash';
export default class Scoring extends Component {
  constructor(props){
    super(props)
    this.state={
      weight:props.value.weight,
      min:props.value.min,
      max:props.value.max,
      NA:props.value.NA,
      Fatal:props.value.Fatal,
      textRating:props.value.textRating,
      negMark:props.value.negMark,
      // NCReason2:props.value.NCReason2,
      // NCReason3:props.value.NCReason3,
      // NCReason4:props.value.NCReason4,
      // NCReason5:props.value.NCReason5,

      
    }
  }
  handleSetStates = (e) => {
    let id = e.target.id
    this.setState({[id]:e.target.value})
    this.props.value[id] = e.target.value
    this.props.CallbackFunctionScoring(this.props.index, this.props.value,'Scoring')
  }
 
  handleCheckbox = (e) => {
    this.setState({[e.target.id]:e.target.checked})    
    this.props.value[e.target.id] = e.target.checked;
    // if(e.target.checked === true){
    //   let object = this.props.payload[e.target.name]
    //   this.props.value[e.target.id+'object'] = object
    // } 
    this.props.CallbackFunctionScoring( this.props.index,this.props.value,'Scoring')
  }
 
  configurtion = () =>{
    this.setState({configureNC:true})
  }
  closeConfigurtion = () =>{
    this.setState({configureNC:false})
  }
  handleSelectedNCReasons = (obj) =>{
    this.props.CallbackFunctionScoring(this.props.index,obj,'NCReasons')      
  }
  

  render(){
    const{weight, min, max, NA, Fatal, textRating, configureNC, negMark} = this.state;

    return(
      <div className='formQuestion'>
        <label>Wtg<span className="RedColoring">*</span><input value={weight} onChange={this.handleSetStates}
            id={'weight'} type='number'/></label>
        <label>Min<span className="RedColoring">*</span><input value={min} onChange={this.handleSetStates}
            id={'min'} type='number'/></label>
        <label>Max {textRating === true ? null : <span className="RedColoring">*</span>}
          <input value={max} onChange={this.handleSetStates}
            id={'max'} type='number'/></label>
          <label>Rating(Yes/No)<center><input checked={textRating === true} onChange={this.handleCheckbox} id={'textRating'} type='checkbox' /></center></label>
          <label>NA<center><input checked={NA === true} onChange={this.handleCheckbox} id={'NA'} type='checkbox'  /></center></label>
          <label>Fatal<center><input checked={Fatal === true} onChange={this.handleCheckbox} id={'Fatal'} type='checkbox'  /></center></label>
          <label>NegativeMarking<center><input checked={negMark === true} onChange={this.handleCheckbox} id={'negMark'} type='checkbox'  /></center></label>
          <label className={"marginTop"}onClick={this.configurtion}><center><b>Click to choose NCReasons</b></center> </label>
          {configureNC === true ?  <NCReasonsTemplate totalObjectNC={this.props.payload} 
          selected={_.cloneDeep(this.props.value)} 
          closeModal={this.closeConfigurtion} onCallBack={this.handleSelectedNCReasons}/>    : null}        
         
          {/* <label>NC Reason 1<center><input checked={NCReason1 === true} name="NC Reason 1" onChange={this.handleCheckbox} id={'NCReason1'} type='checkbox'  /></center></label>
          <label>NC Reason 2<center><input checked={NCReason2 === true} name="NC Reason 2"  onChange={this.handleCheckbox} id={'NCReason2'} type='checkbox'  /></center></label>
          <label>NC Reason 3<center><input checked={NCReason3 === true} name="NC Reason 3"  onChange={this.handleCheckbox} id={'NCReason3'} type='checkbox'  /></center></label>
          <label>NC Reason 4<center><input checked={NCReason4 === true} name="NC Reason 4"  onChange={this.handleCheckbox} id={'NCReason4'} type='checkbox'  /></center></label>
          <label>NC Reason 5<center><input checked={NCReason5 === true} name="NC Reason 5"  onChange={this.handleCheckbox} id={'NCReason5'} type='checkbox'  /></center></label> */}
  
      </div>
      
    )
  }
}
